var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.25 8V13.25H20.75V8H19.25V13.25H14.75V8H13.25V13.25H8V14.75H13.25V19.25H8V20.75H13.25V25.25H8V26.75H26.75V8H25.25ZM25.25 14.75V19.25H20.75V14.75H25.25ZM14.75 14.75H19.25V19.25H14.75V14.75ZM14.75 20.75H19.25V25.25H14.75V20.75ZM20.75 25.25V20.75H25.25V25.25H20.75Z",
    fill: "#90CAF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 2H2V26H8V8H26V2Z",
    fill: "#00BCD4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 1.25V26.75H8.75V8.75H26.75V1.25H1.25ZM2.75 13.25V8.75H7.25V13.25H2.75ZM7.25 14.75V19.25H2.75V14.75H7.25ZM8.75 2.75H13.25V7.25H8.75V2.75ZM14.75 2.75H19.25V7.25H14.75V2.75ZM7.25 2.75V7.25H2.75V2.75H7.25ZM2.75 25.25V20.75H7.25V25.25H2.75ZM25.25 7.25H20.75V2.75H25.25V7.25Z",
    fill: "#0097A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.ef2f8fac820806b4da550858ea0c4c8c.svg";
export { ForwardRef as ReactComponent };